export default __webpack_public_path__ + "static/media/gcpCloud.ad57e5c2.svg";